import { render, staticRenderFns } from "./LargeView.vue?vue&type=template&id=4147e7f8&scoped=true&"
import script from "./LargeView.vue?vue&type=script&lang=js&"
export * from "./LargeView.vue?vue&type=script&lang=js&"
import style0 from "./LargeView.vue?vue&type=style&index=0&id=4147e7f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4147e7f8",
  null
  
)

export default component.exports